import cookies from 'js-cookie';
import { BasicTransport } from '../types';
import logger from '../debug';
import { setPageName } from '../visualize';

const getFields = () => ({
  anonymousId: cookies.get('rl_anonymous_id'),
  url: window.location.href,
  search: window.location.search,
  title: document.title,
  referrer: document.referrer,
});

export const createDebugTransport = (): BasicTransport => ({
  identify: async data => logger.info('identify', { ...getFields(), ...data }),
  page: async data => {
    logger.info('page', { ...getFields(), ...data });
    setPageName(data);
  },
  track: async (name, data) => logger.info(name, { ...getFields(), ...data }),
});
